export default {
  init() {

  },
  finalize() {
    const $dateAttendingField = $('.gfield.date-attending');
    if ($dateAttendingField.length > 0) {
      $dateAttendingField.find('> label').remove();
      $dateAttendingField.find('> .ginput_container').addClass('d-none');

      if ($('.available-dates').find('span').length > 1) {
        const title = $('.banner-title').html();

        const $label = $(`<label class="gfield_label">Date attending ${title}</label>`);
        $dateAttendingField.append($label);

        const $dateChooser = $('<div class="date-chooser"></div>');
        $dateAttendingField.append($dateChooser);

        const $allDates = $('<button type="button" class="date-item all-dates">Attend all dates</button>');
        $dateChooser.append($allDates);

        $allDates.on('click', function() {
          if ($(this).hasClass('selected')) {
            if ($dateChooser.find('.date-item.selected:not(.all-dates)').length > 0) {
              $(this).removeClass('selected');
            }
          } else {
            $dateChooser.find('.date-item.selected:not(.all-dates)').removeClass('selected');
            $(this).addClass('selected');
          }

          setAttendingText();
        })

        $('.available-dates').find('span').each(function(i) {
          const theDate = $(this).html();
          const $date = $(`<button type="button" class="date-item">${theDate}</button>`);

          if (i == 0) {
            $date.addClass('selected');
          }

          $dateChooser.append($date);

          $date.on('click', function() {
            if ($(this).hasClass('selected')) {
              if ($dateChooser.find('.date-item.selected').length > 1) {
                $(this).removeClass('selected');
              }
            } else {
              $dateChooser.find('.date-item.all-dates').removeClass('selected');
              $(this).addClass('selected');
            }

            setAttendingText();
          });
        });
      } else {
        $dateAttendingField.remove();
      }
    }

    function setAttendingText() {
      let text = '';

      $dateAttendingField.find('.date-chooser .date-item.selected').each(function() {
        text += $(this).html() + ',';
      });

      $dateAttendingField.find('> .ginput_container input').val(text);
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/singleEvent.js